import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Alert } from '@mui/material';

export default function AlertDialog(props) {
//   const [open, setOpen] = React.useState(false);
    const {open, setOpen, msg, title, action} = props;

  const handleClose = () => {
    setOpen(false);
  };
  const handleOk=()=>{
    setOpen(false);
    if( action )action();
  }

  return (
    <Dialog
    open={open}
    onClose={handleClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    >
    <DialogTitle id="alert-dialog-title">
        {title}
    </DialogTitle>
    <DialogContent>
        <Alert severity="warning">{msg}</Alert>        
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose}>Cancelar</Button>
        <Button onClick={handleOk}>Ok</Button>
    </DialogActions>
    </Dialog>

  );
}
